import * as React from "react";
const Documents = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 95 95", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { clipPath: "url(#prefix__a)" },
        React.createElement("mask", { id: "prefix__b", width: 95, height: 95, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
                maskType: "luminance",
            } },
            React.createElement("path", { fill: "#fff", d: "M95 0H0v95h95z" })),
        React.createElement("g", { mask: "url(#prefix__b)" },
            React.createElement("path", { fill: "#CFCFCF", d: "M63.2.5H31.7v31.3H.5v62.7h31.3V63.2h31.4V31.8h31.3V.5z" }),
            React.createElement("path", { fill: "#ED0000", d: "M94.5 31.4v63.1H31.4V63H63V31.4z" }),
            React.createElement("path", { fill: "#3F3F3F", d: "M63 63V31.4L31.4 63zM31.7 31.8V.5L.5 31.8z" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "prefix__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h95v95H0z" })))));
export default Documents;
//# sourceMappingURL=Documents.js.map